import { cn } from '../../lib/cn'

/**
 * The club's measure: 1120px, 40px gutters (24px on small screens).
 *
 * `relative z-10` is load-bearing — the paper grain in fireside.css is a fixed
 * layer at z-index 0, and content without a stacking context of its own sits
 * under it and reads muddy.
 */
export function Container({
  children,
  className,
}: {
  children: React.ReactNode
  className?: string
}) {
  return (
    <div className={cn('relative z-10 mx-auto w-full max-w-[1120px] px-6 sm:px-10', className)}>
      {children}
    </div>
  )
}
